import { BehaviorSubject } from "rxjs/internal/BehaviorSubject";
import { i18n } from "../locales/index";

class TranslateService {
  public localeSubject = new BehaviorSubject<string>("en");
  public currentLocale = this.localeSubject.asObservable();
  public language = "en";

  translate(key: string, locale?: string) {
    return i18n.global.t(key, { locale: locale || this.language });
  }

  selectLanguage(lang: any) {
    i18n.global.locale = lang;
    this.language = lang;
    return this.localeSubject.next(lang);
  }
}

export default new TranslateService();
